export const SearchResultProperties = Object.freeze({
    TEXT_FOUND_PREFIX: 'TextFoundPrefix',
    TEXT_FOUND: 'TextFound',
    TEXT_FOUND_SUFFIX: 'TextFoundSuffix',
});
